<template>
  <UserData />
</template>

<script>
export default {
  name: "UserDataPage",
  components: {
    UserData: () => import("@/components/templates/UserData.vue"),
  },
};
</script>

<style></style>
